import React, { useState } from 'react'
import { Icon, Button } from 'antd'
import ReactHTMLTableToExcel from 'react-html-table-to-excel'
import moment from 'moment'
import SewingThreadCopyModal from './SewingThreadCopyModal'

function SewingThreadWarningCompact({ data }) {
    const [copyModalVisible, setCopyModalVisible] = useState(false)
    const { total_items = 0, total_scanned_items = 0, summary = [], items = [] } = data || {}
    const unchangedItems = total_scanned_items - total_items

    const batchList = [...new Set(items.map(i => i.batch_name))].join('-')
    const exportFilename = `mau-chi-may_${batchList}_${moment().format('YYYYMMDD-HHmm')}`
    const exportTableId = 'SewingThreadCompactExportTable'
    const exportBtnId = 'SewingThreadCompactExportBtn'

    return (
        <div className="SewingThreadWarningCompact">
            <div className="TopBlock">
                <Icon type="warning" theme="twoTone" twoToneColor="#faad14" />
                <span> {total_items}/{total_scanned_items} item có màu chỉ may khác với QR đã in</span>
            </div>
            <div className="MiddleBlock">
                {summary.map((s, idx) => (
                    <React.Fragment key={`${s.from}-${s.to}`}>
                        {idx > 0 && ' · '}
                        {s.from_label} → {s.to_label}: {s.quantity}
                    </React.Fragment>
                ))}
                {unchangedItems > 0 && <> · {unchangedItems} item còn lại không đổi</>}
                {'. '}Hãy bàn giao danh sách kèm lệnh may cho đối tác.
            </div>

            <div className="ActionButtons">
                <Button icon="copy" onClick={() => setCopyModalVisible(true)}>Copy danh sách</Button>
                <Button
                    icon="download"
                    onClick={() => document.getElementById(exportBtnId).click()}
                >
                    Export
                </Button>
            </div>

            {copyModalVisible &&
                <SewingThreadCopyModal
                    visible={copyModalVisible}
                    items={items}
                    onClose={() => setCopyModalVisible(false)}
                />
            }

            <div style={{ display: 'none' }}>
                <table id={exportTableId}>
                    <thead>
                        <tr>
                            <th>Lô</th><th>Barcode item</th><th>SKU / Size</th>
                            <th>Màu chỉ trên QR (đã in)</th><th>Màu chỉ cần dùng khi may</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map(i => (
                            <tr key={i.barcode}>
                                <td>{i.batch_name}</td>
                                <td>{i.barcode}</td>
                                <td>{i.sku} / {i.size}</td>
                                <td>{i.printed_label} · {i.printed}</td>
                                <td>{i.current_label} · {i.current}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <ReactHTMLTableToExcel
                    id={exportBtnId}
                    table={exportTableId}
                    filename={exportFilename}
                    sheet="MauChiMay"
                    buttonText="Export Excel"
                />
            </div>
        </div>
    )
}

export default SewingThreadWarningCompact
